// Pricing.jsx
import React from "react";
// import PurchaseAccess from "../components/PurchaseAccess";
import Aanbod from "../components/Aanbod";

const Pricing = ({ animateOnMount = true }) => {
  return (
    <div className="">
      {/* <PurchaseAccess /> */}
      <Aanbod animateOnMount={animateOnMount} />
    </div>
  );
};

export default Pricing;
